import {List} from 'immutable';
export default List([
  {label: '1 day', value: 1},
  {label: '1 week', value: 7},
  {label: '2 weeks', value: 14},
  {label: '1 month', value: 30},
  {label: '2 months', value: 60},
  {label: '3 months', value: 90},
  {label: '6 months', value: 180},
]);
